
import {MouseEvent, useEffect, useMemo, useState} from "react";
import {Row} from "react-table";
import {useTheme} from "@mui/material/styles";
import {dispatch, useSelector} from "store";
import {getList,alertPopupToggle, deleteItem, setPageLimit, setPageNumber,openToggle} from "store/reducers/hr/award";
import {PopupTransition} from "components/@extended/Transitions";
import {CircularProgress, Dialog} from "@mui/material";
import RowActions from "pages/commons/actions";
import AddAward from "./add-edit-award";
import CommonList from "pages/commons/common-list";
import { usePermission } from "hooks/usePermission";
import { PERMISSIONS } from "types/permissions";

const Awards = () => {
    const theme = useTheme();
    const { can } = usePermission();
    
    const { list ,last_page,pageNumber,alertPopup,isLoading,pageLimit,isOpen,total} = useSelector((state) => state.award);
    const [currentAward,setCurrentAward]=useState<any>(null)
    useEffect(() => {
        if((!total && total!=0) || total<0){
            dispatch(getList({search:"",page:1,limit:pageLimit}));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[list] );
    const handleEdit = ((e:MouseEvent,row:Row|any) => {
        setCurrentAward(row.original);
        dispatch(openToggle({isOpen:!isOpen}));
    });
    const columns = useMemo(
        () => [
            {
                Header: '#',
                accessor: 'id',
                className: 'cell-center',
                disableSortBy:true
            },

            {
                Header: 'Award Name',
                accessor: 'award_name',
                disableSortBy: true
            },

            {
                Header: 'Gift',
                accessor: 'gift',
                disableSortBy:true
                // Cell: ({ value }: { value: number }) => <PatternFormat displayType="text" format="(###) ###-####" mask="_" defaultValue={value}  />
            },
            {
                Header: 'Cash Price',
                accessor: 'cash_price',
                disableSortBy: true
            },
            {
                Header: 'For Month',
                accessor: 'for_month',
                disableSortBy: true
            },
            {
                Header: 'For Year',
                accessor: 'for_year',
                disableSortBy: true
            },
            {
                Header: 'Actions',
                className: 'cell-center',
                disableSortBy: true,
                Cell:({ row }: { row: Row })=> <RowActions row={row} actionDisable={{view:true,delete:!can(PERMISSIONS.NL_HR_ADMIN_AWARDS_D),edit:!can(PERMISSIONS.NL_HR_ADMIN_AWARDS_U)}} actionCallBack={{
                    handleView:e => {},
                    handleEdit: handleEdit,
                    handleDelete:  ((e:MouseEvent,row:Row) => {
                        setCurrentAward(row.original);
                        dispatch(alertPopupToggle({alertPopup: true}));
                    })
                }}  />
            }
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [theme]
    );

    const handleSearch=((search:string)=>{
        dispatch(getList({search:search,page:pageNumber,limit:pageLimit}));
    })


    const handleDelete = ((status:boolean) => {
        if(status){
            dispatch(deleteItem(currentAward.id)).then(()=>{

            });
        }
        dispatch(
            alertPopupToggle({
                alertPopup: false
            })
        );
    });

    const handleGoToPage=(page:number)=>{
        dispatch(setPageNumber(page+1));
        dispatch(getList({search:"",page:page+1,limit:pageLimit}));

    }
    const handleSetPageSize=(size:number)=>{
        dispatch(setPageLimit(size));
        dispatch(getList({search:"",page:pageNumber,limit:size}));
    }

    const handleAdd = () => {
        dispatch(openToggle({isOpen:!isOpen}));
        if (currentAward && !isOpen) setCurrentAward(null);
    };
    if(isLoading) return <CircularProgress />;
    return (<>
        <CommonList
            addTitle="Award"
            columns={columns}
            list={list}
            limit={pageLimit}
            last_page={last_page}
            pageNumber={pageNumber}
            handleSearch={handleSearch}
            showAddButton={can(PERMISSIONS.NL_HR_ADMIN_AWARDS_C)}
            deleteProps={{
                title: "Delete",
                alertPopup: alertPopup,
                handleClose: handleDelete
            }}

            handleAdd={handleAdd}
            pageProps={{
                handleGoToPage:handleGoToPage,
                handleSetPageSize: handleSetPageSize
            }} />
        <Dialog
            maxWidth="sm"
            TransitionComponent={PopupTransition}
            keepMounted
            fullWidth
            onClose={handleAdd}
            open={isOpen}
            sx={{ '& .MuiDialog-paper': { p: 0 }, transition: 'transform 225ms' }}
            aria-describedby="alert-dialog-slide-description"
        >
            <AddAward award={currentAward} onCancel={handleAdd} />
        </Dialog>
    </>);
}
export default Awards